import { render } from "./PostsPerCategoryPage.vue?vue&type=template&id=bb6c503a&scoped=true"
import script from "./PostsPerCategoryPage.vue?vue&type=script&lang=js"
export * from "./PostsPerCategoryPage.vue?vue&type=script&lang=js"

import "./PostsPerCategoryPage.vue?vue&type=style&index=0&id=bb6c503a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6c503a"]])

export default __exports__